export default {
  nodes:{
    items: {},
    active: 0,
    next: 0,
  },
}